import { PropsWithChildren, useEffect, useState } from "react";

import styles from "./index.module.scss";

type Props = {
  hidden: boolean;
};

const ApplicationFieldset = ({
  hidden,
  children,
}: PropsWithChildren<Props>) => {
  const [noDisplay, setNoDisplay] = useState(hidden);

  useEffect(() => {
    if (hidden) {
      setTimeout(() => setNoDisplay(true), 500);
    } else {
      setNoDisplay(false);
    }
  }, [hidden]);

  return (
    <fieldset
      className={[
        styles.applicationFieldset,
        hidden ? styles.hidden : null,
      ].join(" ")}
      style={{ display: noDisplay ? "none" : undefined }}
    >
      {children}
    </fieldset>
  );
};

export default ApplicationFieldset;
